const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#007a4c',
                hover: '#00663f'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
